// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6+p0Q","container_video":"styles_container_video__TipIl","video":"styles_video__5d1C5","container_content":"styles_container_content__hiMf3"};